export default __webpack_public_path__ + "static/media/Heorot.ed1bab82.ttf";